import axios from 'axios';

// Create axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

// Request interceptor - add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle specific error codes - ONLY on real server responses
    if (error.response) {
      const status = error.response.status;
      
      if (status === 401) {
        // Token expired or invalid - only on explicit 401
        console.warn('Session expired, redirecting to login...');
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }
      }
      
      if (status === 500) {
        console.error('Server error:', error.response.data);
      }
    } else if (error.request) {
      // Network error - server busy or timeout, do NOT logout
      console.warn('Network error - server may be busy, retrying later');
    }
    
    return Promise.reject(error);
  }
);

// Setup global axios defaults
export const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      // Only logout on explicit 401, never on network errors
      if (error.response?.status === 401) {
        console.warn('Session expired');
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }
      }
      return Promise.reject(error);
    }
  );
};

export default api;
